import React from 'react';

import OverviewPage from '../../templates/overview-page';

import Content from './_assets/content.mdx';

export default () => {
	return (
		<OverviewPage
			categorySlug="license"
			title="License"
			description="Atlassian Design System licensing details, including licence grant, restrictions, and intellectual property information."
			entries={[]}
		>
			<Content />
		</OverviewPage>
	);
};
